import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import MainContent from './mainContent';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import { Comment } from 'ThreeTerminal_pc_dynamic';
import Share from './share';
import Recommend from './recommend';

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { article, recommendInfo, hasCopyRight, sourceReason },
        } = this.props;
        const {
            noAd,
            title,
            summery,
            imagesInContent,
            pcUrl,
            url,
            commentUrl,
            skey,
            contentData,
            editorName,
            editorCode,
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
        } = article;
        const pluginData = {
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
        };

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };
        const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
        const commentConfig = {
            noAd,
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl,
            // 获取评论内容接口
            cmtNumUrl: `//${ commentDomain }/get.php`,
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: `//${ commentDomain }/post.php`,
            // 最热评论数量
            hotLimit: 2,
            // 推荐评论接口
            cmtVoteUrl: `//${ commentDomain }/vote.php`,
            // 现实回复的楼层
            replyLimit: 3,
            // 举报提交接口
            jubUrl: `//${ commentDomain }/report`,
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
            order: 'both', // 'uptimes' 按热度排序，'create_time' 按时间排序， 'both', 两者同时存在
            options: 1, // 0 先显示最新，后显示最热，1 反之，此配置在 order 是 both 的情况下才生效
            recentLimit: 2, // 最近评论数量
            recentReplyLimit: 3, // 最近评论数量显示回复的楼层
        };

        return (
            <div className={styles.leftContent}>
                <div className={styles.artical}>
                    <MainContent
                        content={contentData}
                        pluginData={pluginData}
                        editorName={editorName}
                        editorCode={editorCode}
                        hasCopyRight={hasCopyRight}
                        sourceReason={sourceReason}
                    />
                    <div className="clear" />
                    <Share shareInfo={shareInfo} />
                    <div className={styles.cmt}>
                        <LazyLoad>
                            <Comment articleInfo={commentConfig} />
                        </LazyLoad>
                    </div>
                    {recommendInfo && recommendInfo.length > 0 ? <Recommend data={recommendInfo} /> : ''}
                </div>
            </div>
        );
    }
}

export default errorBoundary(LeftContent);
